/**
 * Переопределяет APP.Plugins.Modals из legacy app.js:
 * без document mousedown, который закрывал попап при клике вне .modal.
 */
export function overrideModalsPlugin() {
  if (!window.APP?.Plugins) {
    return
  }

  window.APP.Plugins.Modals = {
    init() {
      const $ = window.jQuery || window.$
      if (!$?.fn?.magnificPopup) {
        return
      }

      let startWindowScroll = 0

      $('[js-popup]').magnificPopup({
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        closeOnBgClick: false,
        mainClass: 'mfp-zoom-in',
        callbacks: {
          beforeOpen() {
            startWindowScroll = $(window).scrollTop()

            const modalId = this.st.el?.attr('href') || ''
            if (/^#(?:task-modal|report-modal)-/.test(modalId)) {
              this.st.mainClass = 'mfp-zoom-in product-modal-overlay'
            }
          },
          close() {
            $(window).scrollTop(startWindowScroll)
          }
        }
      })
    },
    destroy() {}
  }
}
